import React, { useEffect, useState } from "react";
import { ModalCrosSvg } from "../../../images/Svgs";
import { getRole, AddUser } from "../../../API/Users";
import { toast } from "react-toastify";

const intintian = {
  user_id: "",
  first_name: "",
  last_name: "",
  email: "",
  is_active: 1,
  role_id: "",
  is_access: 1,
  password: "",
  confirm: "",
};

const AddNewUser = ({ onModalClose, editUser }) => {
  const [userData, setUserData] = useState(intintian);
  const [userRoles, setuserRoles] = useState([]);
  const [selectedRoleName, setSelectedRoleName] = useState("");
  const [userError, setUserError] = useState({
    first_name: "",
    last_name: "",
    email: "",
    role_id: "",
    is_active: "",
    is_access: "",
    password: "",
    confirm: "",
  });
  // Add state for password visibility
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const fatchRoles = async () => {
    try {
      const response = await getRole();
      if (response?.status) {
        setuserRoles(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during login request:", error);
    }
  };

  useEffect(() => {
    fatchRoles();
  }, []);

  useEffect(() => {
    if (Object.keys(editUser).length > 0) {
      setUserData((prevData) => ({
        ...prevData,
        ...editUser,
        user_id: editUser.id,
        role_id: editUser.roles ? editUser.roles.id : undefined,
        is_active: editUser.is_active ? 1 : 0,
        is_access: editUser.is_access ? 1 : 0,
        password: "",
      }));

      if (editUser.roles) {
        setSelectedRoleName(editUser.roles.name);
      }
    }
  }, [editUser]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "is_access" || name === "is_active") {
      setUserData({ ...userData, [name]: Number(value) });
    } else {
      setUserData({ ...userData, [name]: value });
    }
    setUserError({ ...userError, [name]: "" });

    // Update selectedRoleName when role_id changes
    if (name === "role_id") {
      const selectedRole = userRoles.find(role => role.id.toString() === value.toString());
      setSelectedRoleName(selectedRole ? selectedRole.name : "");
    }
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };

  // Toggle confirm password visibility
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(prev => !prev);
  };

  const validatePasswordComplexity = (password) => {
    // Check different password requirements
    const hasMinLength = password.length >= 8;
    const hasDigit = /\d/.test(password);
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);
    
    // Return validation state for UI rendering
    return {
      isValid: hasMinLength && hasDigit && hasUpperCase && hasLowerCase && hasSpecialChar,
      requirements: {
        minLength: hasMinLength,
        digit: hasDigit,
        upperCase: hasUpperCase,
        lowerCase: hasLowerCase,
        specialChar: hasSpecialChar
      }
    };
  };

  const validateForm = () => {
    let errors = {};
    let isValid = true;

    // Name validation
    if (!userData.first_name) {
      errors.first_name = "First name is required";
      isValid = false;
    }
    if (!userData.last_name) {
      errors.last_name = "Last name is required";
      isValid = false;
    }
    // Email validation
    if (!userData.email) {
      errors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(userData.email)) {
      errors.email = "Email is not valid";
      isValid = false;
    }

    // Role validation
    if (!userData.role_id) {  
      errors.role_id = "Role is required";
      isValid = false;
    }

    // Status validation
    if (userData.is_active === "") {
      errors.is_active = "Status is required";
      isValid = false;
    }

    // Access validation
    if (userData.is_access === "") {
      errors.is_access = "Access is required";
      isValid = false;
    }

    // Password validation
    if (userData.password === "") {
      errors.password = "Password is required";
      isValid = false;
    } else {
      // Check password complexity
      const passwordValidation = validatePasswordComplexity(userData.password);
      if (!passwordValidation.isValid) {
        errors.password = "";
        isValid = false;
      }
    }

    // Confirm password validation
    if (userData.confirm === "") {
      errors.confirm = "Confirm Password is required";
      isValid = false;
    }
    if (userData.password !== userData.confirm) {
      errors.confirm = "Passwords do not match";
      isValid = false;
    }

    setUserError(errors);
    return isValid;
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      try {
        let payload = userData;
        if (Object.keys(editUser).length > 0) {
          delete payload.roles;
        } else {
          delete payload.user_id;
        }
        const response = await AddUser(payload);
        if (response?.status) {
          toast.success(response.message || "success !");
          onModalClose(false);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error during login request:", error); // Handle any other errors
      }
    } else {
      console.log("Form has errors.");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal fade show">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {Object.keys(editUser).length > 0
                  ? "Update user"
                  : "Add new user"}
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => onModalClose(false)}
              >
                <ModalCrosSvg />
              </button>
            </div>
            <div className="modal-body">
              <div className="event_form">
                <form id="eventForm" onSubmit={(e) => handleSubmit(e)}>
                  {/* Event Title */}
                  <div className="mb-3">
                    <div className="row">
                      <div className="col">
                        <label className="form-label d-flex align-items-center">
                          First Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter first name"
                          name="first_name"
                          value={userData?.first_name}
                          onChange={handleChange}
                          maxLength={20}
                        />
                        {userError.first_name && (
                          <div className="text-danger">
                            {userError.first_name}
                          </div>
                        )}
                      </div>
                      <div className="col">
                        <label className="form-label d-flex align-items-center">
                          Last Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter last name"
                          name="last_name"
                          value={userData?.last_name}
                          onChange={handleChange}
                          maxLength={20}
                        />
                        {userError.last_name && (
                          <div className="text-danger">
                            {userError.last_name}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <div className="row">
                      <div className="col">
                        <label className="form-label d-flex align-items-center">
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter Email"
                          name="email"
                          value={userData?.email}
                          onChange={handleChange}
                        />
                        {userError.email && (
                          <div className="text-danger">{userError.email}</div>
                        )}
                      </div>

                      <div className="col">
                        <label className="form-label d-flex align-items-center">
                          User role
                        </label>
                        <select
                          className="form-select"
                          name="role_id"
                          value={userData?.role_id}
                          onChange={handleChange}
                          disabled={Object.keys(editUser).length > 0}
                        >
                          <option value="">Select</option>
                          {userRoles &&
                            userRoles.length > 0 &&
                            userRoles.map((item) => (
                              <option key={item.id} value={item.id}>{item.name}</option>
                            ))}
                        </select>
                        {userError.role_id && (
                          <div className="text-danger">{userError.role_id}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <div className="row">
                      <div className="col">
                        <label className="form-label d-flex align-items-center">
                          Status
                        </label>
                        <select
                          className="form-select"
                          name="is_active"
                          value={userData?.is_active}
                          onChange={handleChange}
                        >
                          <option value={1}>Active</option>
                          <option value={0}>Deactive</option>
                        </select>
                        {userError.is_active && (
                          <div className="text-danger">
                            {userError.is_active}
                          </div>
                        )}
                      </div>
                      {selectedRoleName === "Staff" && (
                        <div className="col">
                          <label className="form-label d-flex align-items-center">
                            Logistics Access
                          </label>
                          <select
                            className="form-select"
                            name="is_access"
                            value={userData?.is_access}
                            onChange={handleChange}
                          >
                            <option value={1}>Yes</option>
                            <option value={0}>No</option>
                          </select>
                          {userError.is_access && (
                            <div className="text-danger">
                              {userError.is_access}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="row">
                      <div className="col">
                        <label className="form-label d-flex align-items-center">
                          Password
                        </label>
                        <div className="input-group position-relative">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control rounded"
                            placeholder="Enter Password"
                            name="password"
                            value={userData?.password}
                            onChange={handleChange}
                          />
                          <div
                            onClick={togglePasswordVisibility}
                            className="cursor-pointer bg-white  z-10 nd position-absolute d-flex pe-1 align-items-center"
                            style={{ right: "2px", top: "50%", transform: "translateY(-50%)" }}
                          >
                            {showPassword ? (
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" /><circle cx="12" cy="12" r="3" /></svg>
                            ) : (
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye-off"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" /><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" /><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" /><path d="m2 2 20 20" /></svg>
                            )}
                          </div>
                        </div>
                        
                        {userData.password && (
                          <div className="password-requirements">
                            <div className="dot_class"  style={{ color: validatePasswordComplexity(userData.password).requirements.minLength ? "green" : "#DC3545" }}>
                              Password must be at least 8 characters long
                            </div>
                            <div className="dot_class" style={{ color: validatePasswordComplexity(userData.password).requirements.digit ? "green" : "#DC3545" }}>
                              Please enter at least one digit (0-9)
                            </div>
                            <div className="dot_class" style={{ color: validatePasswordComplexity(userData.password).requirements.upperCase && 
                                                validatePasswordComplexity(userData.password).requirements.lowerCase ? "green" : "#DC3545" }}>
                              One uppercase letter (A-Z) and one lowercase letter (a-z) are required
                            </div>
                            <div className="dot_class" style={{ color: validatePasswordComplexity(userData.password).requirements.specialChar ? "green" : "#DC3545" }}>
                              At least one special character (!, @, #, $, %, ^, &) must be included
                            </div>
                          </div>
                        )}
                        
                        {userError.password && typeof userError.password === 'string' && (
                          <div className="text-danger">
                            {userError.password}
                          </div>
                        )}
                      </div>
                      <div className="col">
                        <label className="form-label d-flex align-items-center">
                          Confirm Password
                        </label>
                        <div className="input-group position-relative">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            className="form-control rounded"
                            placeholder="Enter Confirm Password"
                            name="confirm"
                            value={userData?.confirm}
                            onChange={handleChange}
                          />
                          <div
                            onClick={toggleConfirmPasswordVisibility}
                            className="cursor-pointer bg-white z-10 nd position-absolute d-flex pe-1 align-items-center"
                            style={{ right: "2px", top: "50%", transform: "translateY(-50%)" }}
                          >
                            {showConfirmPassword ? (
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye"><path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" /><circle cx="12" cy="12" r="3" /></svg>
                            ) : (
                              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye-off"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" /><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" /><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" /><path d="m2 2 20 20" /></svg>
                            )}
                          </div>
                        </div>
                        {userError.confirm && (
                          <div className="text-danger">{userError.confirm}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-end gap-2">
                    <button
                      type="button"
                      className="btn btn-light"
                      onClick={() => onModalClose(false)}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-dark">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewUser;